import * as yup from "yup";

const urlSchema = yup
  .string()
  .transform((v: string | null | undefined) => {
    if (!v || !v.trim()) return v?.trim();
    const newV = v.trim().toLowerCase();
    if (!newV.startsWith("https://")) {
      return "https://" + v;
    }
    return v;
  })
  .url("Ingrese una URL válida");

export default urlSchema;
